<template>
  <div class="mod-config">
    <div style="border-radius: 30px">
      <el-form :inline="true" size="mini" ref="temp" @keyup.enter.native="getDataList()">
        <el-row>
          <el-form-item label="供应商代码" prop="venderCode">
            <el-input clearable v-model="venderCode" style="width: 200px " placeholder="供应商代码"
                      size="mini" @blur="getDataList"></el-input>
          </el-form-item>
          <el-form-item label="供应商名称" prop="venderName">
            <el-input clearable v-model="venderName" style="width: 200px " placeholder="供应商名称"
                      size="mini" @blur="getDataList"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="applyStatus">
            <el-select clearable v-model="applyStatus" placeholder="请选择" @change="getDataList">
              <el-option v-for="item in options1" :key="item.value" :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="queryHandle()" size="mini" class="filter-item" style="margin-left:20px"
                       icon="el-icon-search">查询
            </el-button>
            <!--<el-button type="danger" size="small" :disabled="dataListSelections.length <= 0"-->
            <!--style="margin-left:20px" @click="UpdateBytongguo()">通过-->
            <!--</el-button>-->
            <!--<el-button type="danger" size="small" :disabled="dataListSelections.length <= 0"-->
            <!--style="margin-left:20px" @click="unQuote()">驳回-->
            <!--</el-button>-->
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div v-loading="dataListLoading">
      <el-table :data="dataList" ref="dataList" size="mini"
                :row-class-name="rowClassName" @selection-change="selectionChangeHandle"
                :height="style.gridStyle.height" :header-cell-style="{background:'#f5f5f5'}" border>
        <el-table-column type="selection" v-model="something" align="center" width="64"></el-table-column>
        <el-table-column header-align="center" label="序号" align="center" width="55">
          <template slot-scope="scope">
            {{ scope.row.rowid }}
          </template>
        </el-table-column>
        <el-table-column prop="applyformNum" header-align="center" align="right" width="120" label="审批单号">
          <template slot-scope="scope">
            {{ scope.row.applyformNum }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="venderCode" header-align="center" align="left" width="120" label="供应商代码">
            <template slot-scope="scope">
                {{ scope.row.venderCode }}
            </template>
        </el-table-column> -->
        <el-table-column prop="venderName" header-align="center" align="left" width="230" label="供应商名称">
          <template slot-scope="scope">
            <el-button type="text" @click="handleUpdate(scope.row)"> {{ scope.row.venderName }}</el-button>
          </template>
        </el-table-column>
        <!--      <el-table-column prop="venderAbbreviation" fixed="left" header-align="center" width="120" label="供应商简称">-->
        <!--        <template slot-scope="scope">-->
        <!--                    {{ scope.row.venderAbbreviation }}-->
        <!--                </template>-->
        <!--         </el-table-column>-->
        <el-table-column prop="sapPayCondition" header-align="center" align="center" label="付款条件">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.sapPayCondition === 'V000'" size="small">预付款</el-tag>
            <el-tag v-if="scope.row.sapPayCondition === 'V001'" size="small">立即付款</el-tag>
            <el-tag v-if="scope.row.sapPayCondition === 'V030'" size="small">30 天账期</el-tag>
            <el-tag v-if="scope.row.sapPayCondition === 'V045'" size="small">45 天账期</el-tag>
            <el-tag v-if="scope.row.sapPayCondition === 'V060'" size="small">60 天账期</el-tag>
            <el-tag v-if="scope.row.sapPayCondition === 'V090'" size="small">90 天账期</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="applyStatus" header-align="center" align="center" width="120" label="状态">
          <template slot-scope="scope">
            <span style="color:#67C23A" v-for="(item, index) in scope.row.applyStatus.split(',')" :key="index"
                  size="mini" type="success">{{ item }}<br></span>
          </template>
        </el-table-column>
        <el-table-column
            prop="pic"
            header-align="center"
            align="center"
            width="120"
            label="当前流程图示">
          <template slot-scope="scope">
            <el-link :disabled="scope.row.applyStatus === '流程结束'" type="primary" style="font-size: 12px;"
                     @click="viewDiagram(scope.row.workflowId, scope.row)"><i class="el-icon-view"
                                                                              style="margin-right: 5px;"></i>查看
            </el-link>
          </template>
        </el-table-column>
        <el-table-column
            prop="pic"
            header-align="center"
            align="center"
            width="120"
            label="评审附件">
          <template slot-scope="scope">
            <el-link type="primary" style="font-size: 12px;" @click="viewThawFile(scope.row)"><i class="el-icon-view"
                                                                                                 style="margin-right: 5px;"></i>查看
            </el-link>
          </template>
        </el-table-column>
        <el-table-column prop="createdName" header-align="center" align="left" width="120" label="申请人">
          <template slot-scope="scope">
            {{ scope.row.createdName }}
          </template>
        </el-table-column>
        <el-table-column prop="createTimeStr" header-align="center" align="right" width="200" label="申请日期">
          <template slot-scope="scope">
            {{ scope.row.createTimeStr }}
          </template>
        </el-table-column>
        <el-table-column prop="disReason" header-align="center" align="center" label="审批历史">
          <template slot-scope="scope">
            <el-button @click="doHistory(scope.row)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column fixed="right" header-align="center" align="center" width="150" label="操作">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.taskActions" :key="index">
              <el-button icon="el-icon-s-check" v-if="!item.flowRuleType" size="small" type="text"
                         @click="execFinish(scope.row.id, item.taskId, scope.row.targetId)">
                批准
              </el-button>
              <div v-if="item.flowRuleType && item.flowRuleType === 'action'">
                <el-button icon="el-icon-circle-check" type="text" size="small"
                           @click="execApprove(scope.row.id, item.taskId, item.flowRuleType, item.normalValue, scope.row.supplierInviteId, scope.row.sapPayCondition, scope.row.supplierId,scope.row.venderName,scope.row.applyformNum)">
                  通过
                </el-button>
                <el-button icon="el-icon-circle-close" type="text" size="small" style="color:#F56C6C"
                           @click="execApprove2(scope.row.id, item.taskId, item.flowRuleType, item.reverseValue, scope.row.supplierInviteId, scope.row.venderName,scope.row.supplierId)">
                  驳回
                </el-button>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle"
                     :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                     :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
    <el-dialog class="abow_dialog " width="90%" top=0 :title="this.activeName" :visible.sync="gpsdialog"
               style="min-height:100px" @close="closegps" :close-on-click-modal="false">
      <div style="min-hight:100px">
        <div style="margin-top:5px">
          <el-tabs class="supplier-info-tabs" v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane name="企业概况" :key="'first'">
              <span slot="label"><span style="color: red">*</span> 企业概况</span>
              <enterprise-profile ref="enterpriseProfile" :superId="this.supplierId"></enterprise-profile>
            </el-tab-pane>
            <el-tab-pane name="主要联系人员" :key="'second'">
              <span slot="label"><span style="color: red">*</span> 主要联系人员</span>
              <main-contacts ref="mainContacts" :superId="this.supplierId"></main-contacts>
            </el-tab-pane>
            <el-tab-pane label="企业资源情况" name="企业资源情况">
              <span slot="label"><span style="color: red">*</span> 企业资源情况</span>
              <resource-info ref="resourceInfo" :superId="this.supplierId"></resource-info>
            </el-tab-pane>
            <el-tab-pane label="工厂及地址" name="工厂及地址">
              <span slot="label"><span style="color: red">*</span> 工厂及地址</span>
              <factory-info ref="factoryInfo" :superId="this.supplierId"></factory-info>
            </el-tab-pane>
            <el-tab-pane label="企业经营状况" name="企业经营状况">
              <span slot="label"><span style="color: red">*</span> 企业经营状况</span>
              <business-info ref="businessInfo" :superId="this.supplierId"></business-info>
            </el-tab-pane>
            <el-tab-pane label="主要产品目录" name="主要产品目录">
              <span slot="label"><span style="color: red">*</span> 主要产品目录</span>
              <product-info ref="productInfo" :superId="this.supplierId"></product-info>
            </el-tab-pane>
            <el-tab-pane label="附件上传" name="附件上传">
              <span slot="label"><span style="color: red">*</span> 附件上传</span>
              <attachment-upload ref="attachmentUpload" :superId="this.supplierId"></attachment-upload>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </el-dialog>

    <el-dialog :title="'确定提示'" width="600px" height="600px" :close-on-click-modal="false"
               :visible.sync="showPayConditionFlag">
      <el-form label-width="100px" :rules="dataRule" :model="dataForm" ref="dataForm">
        <el-form-item prop="venderName" label="供应商名称">
          <el-button type="text">{{ dataForm.venderName }}</el-button>
        </el-form-item>
        <el-form-item prop="sapPayCondition" label="付款条件">
          <el-select clearable="true" v-model="dataForm.sapPayCondition" placeholder="请选择付款条件">
            <!--                        <el-option value="V000" label="预付款"/>
                                    <el-option value="V001" label="立即付款"/>
                                    <el-option value="V030" label="30 天账期"/>
                                    <el-option value="V045" label="45 天账期"/>
                                    <el-option value="V060" label="60 天账期"/>-->
            <el-option
                v-for="item in sapPayConditionList"
                :key="item.sapPayCondition"
                :label="item.sapPayConditionDesc"
                :value="item.sapPayCondition"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="sapZwels" label="付款方式">
          <el-input clearable v-model="dataForm.sapZwels"></el-input>
        </el-form-item>
        <el-form-item label="选择采购组织">
          <el-checkbox-group v-model="dataForm.checkList">
            <el-checkbox v-for="date in purchaseOrgList" :label="date.orgCode + ';' + date.orgName" :key="date.orgCode"
                         disabled>{{ date.orgCode + " " + date.orgName }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showPayConditionFlag = false">取 消</el-button>
        <el-button type="primary" @click="doPassApprove(1)">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="'驳回提示'" width="30%" :close-on-click-modal="false" :visible.sync="unQuoteReasonFlag">
      <el-form label-width="0px" :rules="dataRule" :model="dataForm" ref="dataForm">
        <el-form-item prop="venderName">
          <el-button type="text">{{ dataForm.venderName }}</el-button>
        </el-form-item>
        <el-form-item prop="unQuoteReason">
          <el-input type="textarea" :rows="2" placeholder="请输入驳回原因" v-model="dataForm.unQuoteReason">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="unQuoteReasonFlag = false">取 消</el-button>
        <el-button type="primary" @click="UpdateBybohui()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
        :visible.sync="showViewer"
        width="80%"
        title="流程图">
      <el-image :src="diagramUrl" style="margin-bottom: 120px;">
      </el-image>
    </el-dialog>

    <el-dialog :visible.sync="showWorkflowDialog" width="70%" title="审批进度" :close-on-click-modal="false">
      <div class="workflow-container">
        <div class="workflow-steps">
          <!-- 节点 1: 完善供应商信息 -->
          <div class="step" :class="getStepClass(1, currentWorkflowData)">
            <div class="step-circle">1</div>
            <div class="step-label">完善供应商信息</div>
            <div class="step-status">{{ getStepStatusText(1, currentWorkflowData) }}</div>
          </div>

          <!-- 连线 1→2 -->
          <div class="step-line" :class="getLineClass(1, 2, currentWorkflowData)"></div>

          <!-- 节点 2: 采购工程师审批 -->
          <div class="step" :class="getStepClass(2, currentWorkflowData)">
            <div class="step-circle">2</div>
            <div class="step-label">采购工程师审批</div>
            <div class="step-status">{{ getStepStatusText(2, currentWorkflowData) }}</div>
          </div>

          <!-- 连线 2→3 -->
          <div class="step-line" :class="getLineClass(2, 3, currentWorkflowData)"></div>

          <!-- 节点 3: 采购科长审批 -->
          <div class="step" :class="getStepClass(3, currentWorkflowData)">
            <div class="step-circle">3</div>
            <div class="step-label">采购科长审批</div>
            <div class="step-status">{{ getStepStatusText(3, currentWorkflowData) }}</div>
          </div>

          <!-- 连线 3→4 -->
          <div class="step-line" :class="getLineClass(3, 4, currentWorkflowData)"></div>

          <!-- 节点 4: 采购部长审批 -->
          <div class="step" :class="getStepClass(4, currentWorkflowData)">
            <div class="step-circle">4</div>
            <div class="step-label">采购部长审批</div>
            <div class="step-status">{{ getStepStatusText(4, currentWorkflowData) }}</div>
          </div>

          <!-- 连线 4→5 (根据条件显示) -->
          <div class="step-line" :class="getLineClass(4, 5, currentWorkflowData)"
               v-if="!currentWorkflowData || currentWorkflowData.subcompanyId !== '170'"></div>

          <!-- 节点 5: 采购总监审批 (根据条件显示) -->
          <div class="step" :class="getStepClass(5, currentWorkflowData)"
               v-if="!currentWorkflowData || currentWorkflowData.subcompanyId !== '170'">
            <div class="step-circle">5</div>
            <div class="step-label">采购总监审批</div>
            <div class="step-status">{{ getStepStatusText(5, currentWorkflowData) }}</div>
          </div>

          <!-- 连线 4或5→6 -->
          <div class="step-line"
               :class="getLineClass(currentWorkflowData && currentWorkflowData.subcompanyId === '170' ? 4 : 5, 6, currentWorkflowData)"></div>

          <!-- 节点 6: 流程结束 -->
          <div class="step" :class="getStepClass(6, currentWorkflowData)">
            <div class="step-circle">end</div>
            <div class="step-label">流程结束</div>
            <div class="step-status">{{ getStepStatusText(6, currentWorkflowData) }}</div>
          </div>
        </div>

        <!-- 当前状态说明 -->
        <div class="current-status">
          <h4>当前状态：{{ getCurrentStatusText(currentWorkflowData) }}</h4>
          <p>{{ getCurrentStatusDesc(currentWorkflowData) }}</p>
        </div>
      </div>
    </el-dialog>

    <!-- 文件列表 -->
    <thaw-file v-if="thawFileVisible" ref="thawFile"></thaw-file>

    <el-drawer title="审批履历" :visible.sync="drawer" :with-header="true">
      <div v-for="str in historyList" :key="str">
        <el-descriptions :title="str.executeTime">
          <el-descriptions-item label="审批类型">{{ str.taskName }}</el-descriptions-item>
          <el-descriptions-item label="审批结果">{{ str.executeName }}</el-descriptions-item>
        </el-descriptions>
        <el-divider></el-divider>
      </div>
    </el-drawer>

    <el-dialog
        title="提示"
        :visible.sync="fileDialogVisible"
        width="60%"
        :modal="false"
    >

      <!-- 上传下载 查看 需求文档 -->
      <FileUpDown ref="FileUpDown" :fileSubType="FILE_SUB_TYPE" :bizId="dataForm.id"
                  :bizType="FILE_BIZ_TYPE"></FileUpDown>

      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="fileDialogVisible = false">关 闭</el-button>
          </span>
    </el-dialog>
  </div>
</template>

<script>
import {listApplyForm, execTask2, finishProcess} from '@/controller/supplier'
import {listAllStatus, getProcessDiagramCurrent, listCommentHistory} from '@/controller/workflow'
import ThawFile from './thaw-file'
import FileUpDown from "@/views/common/file-up-down"

import EnterpriseProfile from '@/views/modules/supplier/common/basicInfo/enterpriseProfile'
import MainContacts from '@/views/modules/supplier/common/basicInfo/mainContacts'
import ResourceInfo from '@/views/modules/supplier/common/basicInfo/resourceInfo'
import FactoryInfo from '@/views/modules/supplier/common/basicInfo/factoryInfo'
import BusinessInfo from '@/views/modules/supplier/common/basicInfo/businessInfo'
import ProductInfo from '@/views/modules/supplier/common/basicInfo/productInfo'
import AttachmentUpload from '@/views/modules/supplier/common/basicInfo/attachmentUpload'
import {getPurchaseOrgList} from '@/controller/systemData'
// import { fetchPayConditionList } from '@/controller/systemData'
import {getPayConditionList} from '@/controller/systemData'
import {purList} from "../../../../controller/sys";


export default {
  data() {
    return {
      FILE_BIZ_TYPE: 5,
      FILE_SUB_TYPE: 10,
      fileDialogVisible: false,
      supplierId: '',
      dataForm: {
        venderName: '',
        sapPayCondition: '',
        unQuoteReason: '',
        id: '',
        taskId: '',
        flowType: '',
        sapZwels: 'BT',
        val: '',
        supplierInviteId: '',
        checkList: [],
        venderCode: '',
        applyformNum: null,
        supplierId: ''
      },
      dataRule: {
        unQuoteReason: [{
          required: true,
          message: '驳回原因不能为空',
          trigger: 'blur'
        }]
      },
      activeName: '',
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      showPayConditionFlag: false,
      unQuoteReasonFlag: false,
      thawFileVisible: false,
      venderCode: '',
      venderName: '',
      something: '',
      applyStatus: '',
      gpsdialog: false,
      statusbotton: '0',
      gisIdKey: '',
      applyformId: '',
      targetId: '',
      temp: '',
      nextapplyformId: '',
      style: {
        leftStyle: {
          height: (parseInt(document.documentElement['clientHeight']) - 325) + "px",
          overflow: "auto"
        },
        rightStyle: {
          height: (parseInt(document.documentElement['clientHeight']) - 205) + "px"
        },
        gridStyle: {
          height: (parseInt(document.documentElement['clientHeight']) - 215) + "px"
        }
      },
      options1: [],
      showViewer: false,
      diagramUrl: '',
      // 审批历史
      drawer: false,
      // 审批历史
      historyList: [],
      purchaseOrgList: [],
      sapPayConditionList: [],
      // 新增：工作流相关
      showWorkflowDialog: false,  // 控制工作流对话框显示
      currentWorkflowData: null, // 当前行数据
      statusPriority: {
        '完善供应商信息': 1,
        '采购工程师审批': 2,
        '采购科长审批': 3,
        '采购部长审批': 4,
        '采购总监审批': 5,
        '流程结束': 6
      }
    }
  },
  components: {
    ThawFile,
    EnterpriseProfile,
    ResourceInfo,
    MainContacts,
    FactoryInfo,
    BusinessInfo,
    ProductInfo,
    AttachmentUpload,
    FileUpDown
  },
  activated() {
    if (this.$route.query && this.$route.query.state && this.$route.query.state.length > 0) {
      this.applyStatus = this.$route.query.state
    }
    this.getDataList()
    this.getAllStatus()
  },
  methods: {

    dateFormat: function (row, column) {
      var date = row[column.property]
      if (!date) {
        return ''
      }
      return moment(date).format("YYYY-MM-DD HH:mm:ss")
    },

    viewDiagram(id, row) {
      // 如果能找到对应行数据，则使用新的工作流对话框
      if (row) {
        this.currentWorkflowData = row;
        this.showWorkflowDialog = true;
      } else {
        // 否则使用原来的流程图查看功能
        getProcessDiagramCurrent({id: id}).then(data => {
          this.diagramUrl = data.body;
          this.showViewer = true;
        });
      }
    },

    getStepClass(step, rowData) {
      const status = this.getStepStatus(step, rowData);
      return {
        'step-completed': status === 'completed',
        'step-current': status === 'current',
        'step-pending': status === 'pending'
      };
    },

    // 获取连线样式类
    getLineClass(fromStep, toStep, rowData) {
      const fromStatus = this.getStepStatus(fromStep, rowData);
      const toStatus = this.getStepStatus(toStep, rowData);

      // 如果前一个节点已完成，连线显示为完成状态
      if (fromStatus === 'completed' && (toStatus === 'current' || toStatus === 'completed')) {
        return 'line-completed';
      }
      // 如果前一个节点是进行中，且后一个节点是当前节点
      else if (fromStatus === 'current' && toStatus === 'current') {
        return 'line-active';
      }
      return 'line-pending';
    },

    // 获取步骤状态
    getStepStatus(step, rowData) {
      // 特殊处理：如果subcompanyId为'170'，则跳过第5步（采购总监审批）
      if (rowData && rowData.subcompanyId === '170' && step === 5) {
        return 'skipped';
      }

      // 如果subcompanyId为'170'，第6步实际上是第5步的后续
      let adjustedStep = step;
      if (rowData && rowData.subcompanyId === '170' && step > 4) {
        adjustedStep = step - 1;
      }

      const status = rowData ? rowData.applyStatus : '';
      const priority = this.statusPriority[status] || 0;

      // 定义各状态的预期流程
      let statusSequence;
      if (rowData && rowData.subcompanyId === '170') {
        // subcompanyId为'170'时不包含采购总监审批
        statusSequence = [
          {step: 1, name: '完善供应商信息', requiredStatus: '完善供应商信息'},
          {step: 2, name: '采购工程师审批', requiredStatus: '采购工程师审批'},
          {step: 3, name: '采购科长审批', requiredStatus: '采购科长审批'},
          {step: 4, name: '采购部长审批', requiredStatus: '采购部长审批'},
          {step: 5, name: '流程结束', requiredStatus: '流程结束'}
        ];
      } else {
        // 正常流程包含所有步骤
        statusSequence = [
          {step: 1, name: '完善供应商信息', requiredStatus: '完善供应商信息'},
          {step: 2, name: '采购工程师审批', requiredStatus: '采购工程师审批'},
          {step: 3, name: '采购科长审批', requiredStatus: '采购科长审批'},
          {step: 4, name: '采购部长审批', requiredStatus: '采购部长审批'},
          {step: 5, name: '采购总监审批', requiredStatus: '采购总监审批'},
          {step: 6, name: '流程结束', requiredStatus: '流程结束'}
        ];
      }

      // 找到当前步骤对应的配置
      const currentStepConfig = statusSequence.find(s => s.step === adjustedStep);
      if (!currentStepConfig) return 'pending';

      // 如果当前状态等于该步骤的状态，则为进行中
      if (status === currentStepConfig.requiredStatus) {
        return 'current';
      }

      // 如果当前状态优先级高于该步骤的状态，则为已完成
      if (priority > this.statusPriority[currentStepConfig.requiredStatus]) {
        return 'completed';
      }

      // 否则为待处理
      return 'pending';
    },

    // 获取步骤状态文本
    getStepStatusText(step, rowData) {
      const status = this.getStepStatus(step, rowData);
      switch (status) {
        case 'completed':
          return '✓ 已完成';
        case 'current':
          return '▶ 进行中';
        case 'pending':
          return '○ 待处理';
        case 'skipped':
          return '— 已跳过';
        default:
          return '';
      }
    },

    // 获取当前状态文本
    getCurrentStatusText(rowData) {
      const statusMap = {
        '完善供应商信息': '完善供应商信息',
        '采购工程师审批': '等待采购工程师审批',
        '采购科长审批': '等待采购科长审批',
        '采购部长审批': '等待采购部长审批',
        '采购总监审批': '等待采购总监审批',
        '流程结束': '流程已完成'
      };

      if (rowData && rowData.applyStatus) {
        if (rowData.subcompanyId === '170' && rowData.applyStatus === '流程结束') {
          return '流程已完成（无采购总监审批）';
        }
        return statusMap[rowData.applyStatus] || rowData.applyStatus;
      }

      return '';
    },

    // 获取当前状态描述
    getCurrentStatusDesc(rowData) {
      const descMap = {
        '完善供应商信息': '正在完善供应商基本信息',
        '采购工程师审批': '采购工程师正在审核供应商资料',
        '采购科长审批': '采购科长正在审核供应商资料',
        '采购部长审批': '采购部长正在审核供应商资料',
        '采购总监审批': '采购总监正在审核供应商资料',
        '流程结束': '所有审批环节已完成，供应商准入申请通过'
      };

      if (rowData && rowData.applyStatus) {
        if (rowData.subcompanyId === '170' && rowData.applyStatus === '流程结束') {
          return '所有审批环节已完成，供应商准入申请通过（已跳过采购总监审批）';
        }
        return descMap[rowData.applyStatus] || '暂无状态描述';
      }

      return '暂无状态描述';
    },

    getAllStatus() {
      listAllStatus({
        'processDefKey': 'QSA1'
      }).then(data => {
        if (data && data.code === '00') {
          this.options1 = data.body.map(str => {
            return {'value': str, 'label': str}
          })
        }
      })
    },
    execFinish(id, taskId, targetId) {
      finishProcess({
        'id': id,
        'taskId': taskId,
        'targetId': targetId
      }).then(data => {
        if (data && data.code === '00') {
          this.getDataList()
        }
      })
    },
    // 查询按钮
    queryHandle() {
      this.pageIndex = 1
      this.getDataList()
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      listApplyForm({
        'pageNo': this.pageIndex,
        'pageSize': this.pageSize,
        'venderCode': this.venderCode,
        'venderName': this.venderName,
        'key': this.dataForm.key,
        'applyStatus': this.applyStatus,
        'approvedBy': this.approvedBy,
        'approveLevel': 0,
        'applyformType': '10',
      }).then(data => {
        if (data && data.code === '00') {
          this.dataList = data.body.records
          this.totalPage = data.body.total
        } else {
          this.dataList = []
          //  this.totalPage = 0
        }
      }).catch((e) => {
        console.log(e)
      }).finally(() => {
        this.dataListLoading = false
      })
    },

    //驳回原因
    unQuote() {
      this.dataForm.unQuoteReason = ""
      this.unQuoteReasonFlag = true
    },

    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle(val) {
      // debugger
      this.dataListSelections = val
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },

    rowClassName({
                   row,
                   rowIndex
                 }) {
      //把每一行的索引放进row.id
      row.rowid = rowIndex + 1 + (this.pageSize * (this.pageIndex - 1));
    },
    handleClick: function () {
      if (this.activeName === '企业概况') {
        this.$refs.enterpriseProfile.getDataList(this.superId)
      }
      if (this.activeName === '主要联系人员') {
        this.$refs.mainContacts.getDataList(this.superId)
      }
      if (this.activeName === '企业资源情况') {
        this.$refs.resourceInfo.getDataList(this.superId)
      }
      if (this.activeName === '工厂及地址') {
        this.$refs.factoryInfo.getDataList(this.superId)
      }
      if (this.activeName === '企业经营状况') {
        this.$refs.businessInfo.getDataList(this.superId)
      }
      if (this.activeName === '体系认证情况') {
        this.$refs.certificationInfo.getDataList(this.superId)
      }
      if (this.activeName === '主要产品目录') {
        this.$refs.productInfo.getDataList(this.superId)
      }
      if (this.activeName === '主要设备清单') {
        this.$refs.equipmentList.getDataList(this.superId)
      }
      if (this.activeName === '附件上传') {
        this.$refs.attachmentUpload.getDataList(this.superId)
      }
    },
    handleUpdate(row) {
      this.gisIdKey = row.targetId
      this.gpsPid = row.pid
      this.activeName = '企业概况'
      this.gpsdialog = true
      this.targetId = row.targetId
      this.applyformId = row.applyformId
      this.statusbotton = row.applyStatus
      this.nextapplyformId = row.nextapplyformId
      this.approveLevel = row.approveLevel
      this.updatedBy = row.updatedBy
      this.supplierId = row.supplierInviteId
      this.superId = row.supplierInviteId
      this.$nextTick(() => {
        this.$refs.enterpriseProfile.getDataList(row.supplierInviteId)
      })
    },
    closegps() {
      this.getDataList()
    },

    // 显示文件列表
    viewThawFile(row) {
      this.dataForm.id = row.id
      this.fileView()
    },

    //通过
    execApprove(id, taskId, flowType, val, supplierInviteId, sapPayCondition, supplierId, venderName, applyformNum) {
      this.dataForm.sapPayCondition = sapPayCondition;
      this.dataForm.id = id;
      this.dataForm.taskId = taskId;
      this.dataForm.flowType = flowType;
      this.dataForm.val = val;
      this.dataForm.supplierInviteId = supplierInviteId;
      this.dataForm.venderName = venderName;
      this.dataForm.applyformNum = applyformNum;
      this.dataForm.supplierId = supplierId;
      console.log('通过', this.dataForm);
      if (!sapPayCondition || null == sapPayCondition || '' == sapPayCondition) {
        //查找采购组织数据
        this.purchaseOrgList = this.getPurchaseOrgList();
        this.getSapPayConditionList();
        // 付款条件为空，则弹窗修改
        this.showPayConditionFlag = true;
      } else {
        // 付款条件非空，则直接通过
        this.doPassApprove(2);
      }
    },

    //驳回
    execApprove2(id, taskId, flowType, val, supplierInviteId, venderName, supplierId) {
      this.dataForm.unQuoteReason = '';
      this.dataForm.id = id;
      this.dataForm.taskId = taskId;
      this.dataForm.flowType = flowType;
      this.dataForm.val = val;
      this.dataForm.supplierInviteId = supplierInviteId;
      this.dataForm.venderName = venderName;
      this.dataForm.supplierId = supplierId;
      this.unQuoteReasonFlag = true;
      console.log('驳回', this.dataForm);
    },

    // 通过页面的确定
    doPassApprove(isPurOrg) {
      if (undefined == this.dataForm.sapPayCondition || '' == this.dataForm.sapPayCondition) {
        this.$message.error("请设置该供应商的付款条件");
        return;
      }
      // //判断是否选择了采购组织
      // if (isPurOrg == 1 && (undefined == this.dataForm.checkList || 0 == this.dataForm.checkList.length)) {
      //     this.$message.error("请选择采购组织");
      //     return;
      // }
      this.dataListLoading = true
      this.$confirm(`确定账期并进行通过操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        execTask2({
          'id': this.dataForm.id,
          'taskId': this.dataForm.taskId,
          'paramKey': this.dataForm.flowType,
          'paramVal': this.dataForm.val,
          'targetId': this.dataForm.supplierInviteId,
          'sapPayCondition': this.dataForm.sapPayCondition,
          'purgrps': this.dataForm.checkList,
          'supplierId': this.dataForm.supplierId,
          'applyformNum': this.dataForm.applyformNum,
          'passOrReject': '1',
          'sapZwels': this.dataForm.sapZwels
        }).then(data => {
          if (data && data.code === '00') {
            this.getDataList()
            this.$message({
              message: '更新成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.visible = false
                this.$emit('refreshDataList')
                this.showPayConditionFlag = false
              }
            })
          } else {
            this.$message.error(data.msg)
          }
          this.showPayConditionFlag = false
        })

      })
    },


    // 驳回页面的确定
    UpdateBybohui() {
      this.$confirm(`确定进行驳回操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        let params = {
          'id': this.dataForm.id,
          'taskId': this.dataForm.taskId,
          'paramKey': this.dataForm.flowType,
          'paramVal': this.dataForm.val,
          'targetId': this.dataForm.supplierInviteId,
          'unQuoteReason': this.dataForm.unQuoteReason,
          'supplierId': this.dataForm.supplierId,
          'passOrReject': '0',
        }

        execTask2(params).then(data => {
          if (data && data.code === '00') {
            this.getDataList()
            this.$message({
              message: '驳回成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.visible = false
                this.$emit('refreshDataList')
                this.showPayConditionFlag = false
                this.unQuoteReasonFlag = false
              }
            })
          } else {
            this.$message.error(data.msg)
          }
          this.unQuoteReasonFlag = false
        })

      })
    },

    // 审批历史
    doHistory(row) {
      this.historyList = []
      listCommentHistory({'workflowId': row.workflowId}).then(data => {
        if (data && data.code === '00') {
          this.historyList = data.body
        } else {
          this.$message.error(data.msg)
        }
      })
      this.drawer = true
    },

    // 文件列表
    fileView() {
      this.fileDialogVisible = true
      this.$nextTick(() => {
        this.$refs.FileUpDown.init(this.dataForm.id, this.FILE_BIZ_TYPE, null)
      })
    },
    // 下拉输入采购组织
    getPurchaseOrgList() {
      purList({}).then(data => {
        if (data && data.code === '00') {
          this.purchaseOrgList = data.body;
          this.dataForm.checkList = this.purchaseOrgList.map((item) => {
            return `${item.orgCode};${item.orgName}`
          })
        }
      });
    },

    // 获取付款条件（账期）下拉列表
    getSapPayConditionList() {
      getPayConditionList({
        'sapPayCondition': '',
        'sapPayConditionDesc': ''
      }).then(data => {
        if (data && data.code === '00') {
          // console.log(data)
          this.sapPayConditionList = data.body
        }
      }).catch((e) => {
        console.log(e)
      })
    }
  }
}
</script>

<style scoped>
.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.abow_dialog /deep/ .el-dialog {
  margin: 0 auto !important;
  height: 90%;
  display: flex;
  flex-direction: column;
}

.abow_dialog /deep/ .el-dialog .el-dialog__body {
  flex: 1;
  overflow-y: auto;
}

/* 工作流样式 */
.workflow-container {
  padding: 20px;
}

.workflow-steps {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin: 40px 0;
  padding: 0 20px;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  min-width: 100px;
}

.step-circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #e4e7ed;
  color: #606266;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  border: 3px solid #e4e7ed;
  transition: all 0.3s ease;
  margin-bottom: 10px;
}

.step-label {
  font-size: 12px;
  color: #303133;
  text-align: center;
  font-weight: 500;
  margin-bottom: 5px;
  width: 100px;
  word-wrap: break-word;
}

.step-status {
  font-size: 12px;
  color: #909399;
  text-align: center;
}

/* 步骤状态样式 */
.step-completed .step-circle {
  background: #67c23a;
  color: white;
  border-color: #67c23a;
}

.step-current .step-circle {
  background: #409eff;
  color: white;
  border-color: #409eff;
  animation: pulse 2s infinite;
}

.step-pending .step-circle {
  background: #e4e7ed;
  color: #606266;
  border-color: #e4e7ed;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(64, 158, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0);
  }
}

/* 连线样式 */
.step-line {
  flex: 1;
  height: 4px;
  background: #e4e7ed;
  margin: 0 10px;
  position: relative;
  top: -22px;
  transition: all 0.3s ease;
}

.line-completed {
  background: #67c23a;
}

.line-active {
  background: linear-gradient(90deg, #67c23a 0%, #409eff 100%);
}

.line-pending {
  background: #e4e7ed;
}

/* 当前状态说明 */
.current-status {
  margin-top: 40px;
  padding: 20px;
  background: #f5f7fa;
  border-radius: 8px;
  border-left: 4px solid #409eff;
}

.current-status h4 {
  margin: 0 0 10px 0;
  color: #303133;
  font-size: 16px;
}

.current-status p {
  margin: 0;
  color: #606266;
  line-height: 1.6;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .workflow-steps {
    flex-direction: column;
    gap: 30px;
  }

  .step-line {
    width: 4px;
    height: 40px;
    margin: 10px 0;
    top: 0;
  }
}

/* 跳过状态样式 */
.step .step-status:after {
  content: "";
}

.step-skipped .step-circle {
  background: #909399;
  color: white;
  border-color: #909399;
}
</style>
